import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { useEffect, useState } from "react";
import { UserRole, UserTransport } from "src/app/transports/user";

const useProofreaderOptions = () => {
    const [proofreaderOptions, setProofreaderOptions] = useState<Array<SimpleFormSelectOption>>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    useEffect(() => {
        setLoading(true);
        UserTransport.listOptions({
            roles: [
                UserRole.ROLE_PROOFREADER.toString(),
                UserRole.ROLE_LEAD_PROOFREADER.toString(),
            ],
            isActive: 1,
        })
            .then((res) => {
                setProofreaderOptions(res);
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    }, []);

    return { proofreaderOptions, loading, error };
};

export default useProofreaderOptions;
